<template lang="pug">
.cb-datepicker(v-if="datepickerIsOpened")
  span.cb-datepicker__label {{ label }}
  .navigation
    button.navigation__btn.navigation__btn--prev(type="button" @click="prevMonth")
    span.navigation__month {{ currentMonthString }} {{ currentYear }}
    button.navigation__btn.navigation__btn--next(type="button" @click="nextMonth")
  .calendar(v-if="datepickerIsOpened")
    .day.day--header(v-for="dayWeek in daysHeader") {{ dayWeek }}
    button.day(
      type="button"
      v-for="(day, index) in maxDayFromMonth"
      :class="dayClass(day)"
      :style="dayStyle(index)"
      :disabled="isDateDisable(day)"
      @click="selectDay(day)"
    ) {{ day }}
</template>

<script>
// Pegar data atual
let today = new Date()
// Pega data do dia seguinte
// const tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000))

function number (value) {
  return value.toString().length === 1 ? `0${value}` : value
}

function outsideClick (e) {
  let target = document.querySelector(this.target)
  if (this.$el && this.$el.contains(e.target) === false && target && target.contains(e.target) === false && this.datepickerIsOpened === true) {
    this.closeDatepicker()
  }
}

export default {
  props: {
    label: String,
    target: String,
    value: Date,
    min: Date,
    max: Date,
    visible: {
      type: Boolean,
      default: false
    },
    closeEvent: Function
  },
  data () {
    return {
      daysHeader: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'],
      currentYear: (this.value || today).getFullYear(),
      currentMonth: (this.value || today).getMonth(),
      currentDay: (this.value || today).getDate(),
      selectedDay: (this.value || today).getDate(),
      selectedDate: (this.value || today),
      datepickerIsOpened: this.visible
    }
  },
  computed: {
    minDayFromMonth () {
      return new Date(this.currentYear, this.currentMonth, 1).getDate()
    },
    maxDayFromMonth () {
      return new Date(this.currentYear, (this.currentMonth + 1), 0).getDate()
    },
    firstDayOfWeekFromMonth () {
      return new Date(this.currentYear, this.currentMonth, 1).getDay()
    },
    currentMonthString () {
      return new Date(this.currentYear, this.currentMonth, 1).toLocaleDateString('pt-br', { month: 'long' })
    }
    // displayValue () {
    //   return this.selectedDate.toLocaleDateString('pt-br', { year: 'numeric', month: 'numeric', day: 'numeric' })
    // }
  },
  watch: {
    value (newValue, oldValue) {
      if (newValue) {
        this.currentYear = newValue.getFullYear()
        this.currentMonth = newValue.getMonth()
        this.currentDay = newValue.getDate()
        this.selectedDay = newValue.getDate()
        this.selectedDate = newValue
      }
    },
    visible (newValue, oldValue) {
      this.datepickerIsOpened = newValue
    }
  },
  methods: {
    dayClass (value) {
      return {
        'day--current': this.isCurrentDay(value),
        'day--selected': this.isSelectDay(value)
      }
    },
    dayStyle (index) {
      if (index === 0) {
        let marginLeft = (this.firstDayOfWeekFromMonth * 40) + 2
        return { marginLeft: `${marginLeft}px` }
      } else {
        return null
      }
    },
    openDatepicker () {
      this.datepickerIsOpened = true
    },
    closeDatepicker () {
      this.closeEvent()
      this.datepickerIsOpened = false
    },
    prevMonth () {
      if (this.currentMonth === 0) {
        this.currentMonth = 11
        this.currentYear = this.currentYear - 1
      } else {
        this.currentMonth = this.currentMonth - 1
      }
    },
    nextMonth () {
      if (this.currentMonth === 11) {
        this.currentMonth = 0
        this.currentYear = this.currentYear + 1
      } else {
        this.currentMonth = this.currentMonth + 1
      }
    },
    selectDay (value) {
      this.selectedDate = new Date(this.currentYear, this.currentMonth, value)
      this.selectedDay = value
      this.closeDatepicker()
      this.$emit('input', this.selectedDate)
      this.$emit('change', this.selectedDate)
    },
    isCurrentDay (day) {
      return today.toDateString() === new Date(this.currentYear, this.currentMonth, day).toDateString()
    },
    isSelectDay (day) {
      return this.selectedDate.toDateString() === new Date(this.currentYear, this.currentMonth, day).toDateString()
    },
    isDateDisable (day) {
      let currentDay = new Date(this.currentYear, this.currentMonth, day)
      return currentDay < this.min || currentDay > this.max
    }
  },
  filters: {
    number
  },
  mounted () {
    this.$nextTick(() => {
      document.addEventListener('click', outsideClick.bind(this))
      document.addEventListener('touchstart', outsideClick.bind(this))
    })
  },
  destroyed () {
    this.$nextTick(() => {
      document.removeEventListener('click', outsideClick.bind(this))
      document.removeEventListener('touchstart', outsideClick.bind(this))
    })
  }
}
</script>

<style lang="scss" scoped>
@import "~@/style/ui/variables";

.date {
  cursor: pointer;
  display: flex;
  position: relative;
}

.step__datepicker--icon {
  background: url(../../assets/calendar-white.svg) no-repeat center;
  display: block;
  margin-right: 5px;

  @media screen and (max-width: 767px) {
    background-size: cover;
    height: 24px;
    width: 24px;
  }

  @media screen and (min-width: 767px) {
    height: 48px;
    width: 48px;
  }
}

.date__input {
  background: transparent;
  border: none;
  color: $white;
  font-family: Oscine;
  font-size: 32px;
  font-weight: bold;
  outline: none;
  width: 100%;
}

.cb-datepicker {
  background: $white;
  border-radius: 5px;
  box-shadow: 4px 5px 4px 2px rgba(155, 155, 155, 0.4);
  box-sizing: border-box;
  color: $black;
  z-index: 3;
  padding: 16px;
  position: absolute;
  top: 36px;
  width: 312px;
  z-index: 2;

  @media screen and (max-width: 540px) {
    left: calc(50% - 144px);
    padding: 16px 4px;
    position: fixed;
    top: 70px;
    width: 288px;
  }
}

.cb-datepicker__label {
  display: block;
  font-size: 16px;
  text-align: center;
  width: 100%;
}

#step__datepicker-group--end .cb-datepicker {
  @media screen and (min-width: 541px) and (max-width: 650px),
  screen and (min-width: 1001px) and (max-width: 1250px) {
    right: -40px;
  }
}

.navigation {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.navigation__btn {
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  height: 42px;
  justify-content: center;
  outline: none;
  vertical-align: middle;
  width: 42px;
  color: $black;
  fill: $black;

  img {
    height: 28px;
    width: 28px;
  }
}

.navigation__btn--prev {
  background: url(~@/assets/arrow-back.svg) center center no-repeat;
  background-size: 25%;
}

.navigation__btn--next {
  background: url(~@/assets/arrow-back.svg) center center no-repeat;
  background-size: 25%;
  transform: rotate(-180deg);
}

.navigation__month {
  color: $black;
  font-family: Oscine;
  font-size: 24px;
  text-transform: capitalize;
}

.calendar {
  display: flex;
  flex-wrap: wrap;
  height: 240px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.day {
  align-items: center;
  background: transparent;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 30px;
  font-size: 16px;
  margin: 2px;
  justify-content: center;
  outline: none;
  width: 36px;
}

.day:hover {
  background-color: rgba($color-purple-heart, .6);
  border-color: transparent;
  border-radius: 8px;
  color: $white;

  .themeBB & {
    background-color: rgba(#0038a8, .6);
  }
}

.day[disabled] {
  color: #CCC;
  cursor: not-allowed;
}

.day--header {
  font-weight: 700;
  pointer-events: none;
}

.day--current {
  border: 2px solid $color-purple-heart;
  border-radius: 8px;

  .themeBB & {
    border-color: #0038a8;
  }
}

.day--selected {
  background-color: $color-purple-heart;
  border-radius: 8px;
  color: $white;
  font-weight: 700;

  .themeBB & {
    background-color: #0038a8;
  }
}
</style>
